import { Fragment } from "vue";
function flattenFragments(nodes) {
  return nodes.map((node) => {
    if (node.type === Fragment) {
      return flattenFragments(node.children);
    }
    return node;
  }).flat();
}
export {
  flattenFragments as f
};
//# sourceMappingURL=flattenFragments-BoFLyuna.mjs.map
